import { ReactNode } from 'react';
import styles from './style.module.scss';

type Props = {
  children: ReactNode
}

const NoticeText = ({ children }: Props) => {
  return (
    <div className={styles.noticeText}>
      {children}
    </div>
  )
}

export { NoticeText }
